(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cubsley-ambient-film"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cb-ambient-film')) {
  customElements.define('cb-ambient-film', class extends HTMLElement {
    connectedCallback() {
      if (this.abort && !this.abort.signal.aborted) return;
      this.abort = new AbortController();
      this.button = this.querySelector('.cb-ambient-toggle');
      if (!this.button) return;
      this.mobile = matchMedia('(max-width:749px)');
      this.motion = matchMedia('(prefers-reduced-motion:reduce)');
      this.userPaused = false;
      const box = this.getBoundingClientRect();
      this.visible = box.bottom > 0 && box.top < innerHeight && box.width > 0;
      const options = {signal:this.abort.signal};
      this.button.addEventListener('click', () => {
        if (this.player && !this.player.paused) {
          this.userPaused = true;
          this.player.pause();
        } else {
          this.userPaused = false;
          this.mount();
          this.play(true);
        }
      }, options);
      this.mobile.addEventListener('change', () => this.reconfigure(), options);
      this.motion.addEventListener('change', () => this.reconfigure(), options);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.player?.pause();
        else this.resume();
      }, options);
      window.addEventListener('pageshow', () => this.resume(), options);
      window.addEventListener('pagehide', () => this.player?.pause(), options);
      const retryAfterGesture = () => {
        if (this.dataset.autoplayBlocked === 'true') this.resume();
      };
      document.addEventListener('pointerdown', retryAfterGesture, options);
      document.addEventListener('keydown', retryAfterGesture, options);
      this.configure();
      // Warm up the one selected file immediately, including on phones below the fold.
      if (this.auto) this.mount();
      this.resume();
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        if (this.visible) this.resume();
        else this.player?.pause();
      }, {threshold:0});
      this.observer.observe(this);
    }
    configure() {
      const mode = this.mobile.matches ? this.dataset.mobile : 'inherit';
      this.posterOnly = this.mobile.matches && mode === 'poster';
      this.auto = !this.posterOnly && !this.motion.matches &&
        !navigator.connection?.saveData &&
        (mode === 'autoplay' || mode === 'inherit' && this.dataset.autoplay === 'true');
      this.template = this.querySelector(this.mobile.matches ?
        'template[data-device=mobile]' : 'template[data-device=desktop]');
      this.button.hidden = this.posterOnly || !this.template;
      this.updateButton();
    }
    mount() {
      if (this.player || !this.template || this.posterOnly) return;
      const video = this.template.content.firstElementChild.cloneNode(true);
      this.player = video;
      this.filmId = this.template.dataset.filmId;
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.controls = false;
      video.removeAttribute('controls');
      video.disablePictureInPicture = true;
      video.disableRemotePlayback = true;
      video.loop = this.dataset.loop === 'true';
      video.preload = 'auto';
      video.autoplay = this.auto && this.visible && !document.hidden;
      const sources = [...video.querySelectorAll('source')].sort((a,b) =>
        Number(a.dataset.width) - Number(b.dataset.width));
      const targetWidth = this.clientWidth * Math.min(devicePixelRatio || 1, 1.25);
      const selected = sources.find(s => Number(s.dataset.width) >= targetWidth) || sources.at(-1);
      if (selected) {
        video.src = selected.src;
        sources.forEach(source => source.remove());
      }
      video.addEventListener('play', () => this.updateButton());
      video.addEventListener('playing', () => {
        this.dataset.autoplayBlocked = 'false';
        const reveal = () => {
          if (this.player === video && video.readyState >= 2) this.dataset.frameReady = 'true';
        };
        if (video.requestVideoFrameCallback) video.requestVideoFrameCallback(reveal);
        else requestAnimationFrame(reveal);
        this.updateButton();
      });
      video.addEventListener('pause', () => this.updateButton());
      video.addEventListener('canplay', () => this.resume());
      video.addEventListener('ended', () => {
        // A paused frame remains visible; never flash the poster at a loop boundary.
        if (video.loop && this.auto && !this.userPaused) this.resume();
        this.updateButton();
      });
      video.addEventListener('error', () => {
        if (this.player !== video) return;
        this.dataset.frameReady = 'false';
        this.updateButton();
      });
      this.insertBefore(video, this.button);
      video.load();
    }
    resume() {
      if (!this.auto || !this.visible || this.userPaused || document.hidden) return;
      this.mount();
      this.play(false);
    }
    play(manual) {
      const video = this.player;
      if (!video || document.hidden || this.pendingPlay) return;
      if (!manual && (!this.auto || !this.visible || this.userPaused)) return;
      if (!video.paused) return;
      video.muted = true;
      const attempt = video.play();
      if (!attempt) return;
      this.pendingPlay = attempt;
      attempt.catch(error => {
        if (this.player !== video) return;
        if (error.name === 'NotAllowedError') this.dataset.autoplayBlocked = 'true';
        this.updateButton();
      }).finally(() => {
        if (this.pendingPlay === attempt) this.pendingPlay = null;
      });
    }
    updateButton() {
      if (!this.button) return;
      const playing = !!this.player && !this.player.paused && !this.player.ended;
      this.dataset.playing = String(playing);
      this.button.setAttribute('aria-label', playing ? this.dataset.labelPause : this.dataset.labelPlay);
      this.button.setAttribute('aria-pressed', String(playing));
    }
    reconfigure() {
      this.configure();
      const sameFilm = this.player && this.filmId === this.template?.dataset.filmId;
      if (!sameFilm || this.posterOnly) {
        this.player?.pause();
        this.player?.remove();
        this.player = null;
        this.pendingPlay = null;
        this.dataset.frameReady = 'false';
      } else if (!this.auto) {
        this.player.autoplay = false;
        this.player.pause();
      }
      if (this.auto && !this.userPaused) this.mount();
      this.resume();
    }
    disconnectedCallback() {
      this.player?.pause();
      this.observer?.disconnect();
      this.abort?.abort();
      this.player?.remove();
      this.player = null;
      this.pendingPlay = null;
      this.dataset.frameReady = 'false';
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cubsley-language"] && !Shopify.designMode) return;
  try {
    (() => {
  const preferenceKey = 'cubsley.language';
  const sessionKey = 'cubsley.language.detected';
  const storageRead = (storage, key) => { try { return window[storage].getItem(key); } catch { return null; } };
  const storageWrite = (storage, key, value) => { try { window[storage].setItem(key, value); } catch {} };
  document.addEventListener('submit', event => {
    const button = event.submitter;
    if (!event.target.matches('.cb-language-form') || button?.name !== 'language_code') return;
    storageWrite('localStorage', preferenceKey, button.value);
    storageWrite('sessionStorage', sessionKey, '1');
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('.cb-language[open]').forEach(details => {
      if (!details.contains(event.target)) details.removeAttribute('open');
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.cb-language[open]').forEach(details => {
      details.removeAttribute('open');
      details.querySelector('summary').focus();
    });
  });
  const detect = () => {
    const options = document.querySelector('[data-cb-language-options][data-auto="true"]');
    if (!options || storageRead('sessionStorage', sessionKey)) return;
    if (options.dataset.root.replace(/\/$/, '') !== '') return;
    const languages = Array.from(options.querySelectorAll('button[name="language_code"]'), button => button.value);
    const preferred = storageRead('localStorage', preferenceKey);
    const requested = preferred ? [preferred] : navigator.languages || [navigator.language];
    let target = null;
    for (const language of requested) {
      const normalized = String(language || '').toLowerCase();
      target = languages.find(code => code.toLowerCase() === normalized) || languages.find(code => code.toLowerCase() === normalized.split('-')[0]);
      if (target) break;
    }
    target = target || languages.find(code => code === 'en');
    if (!target) return;
    storageWrite('sessionStorage', sessionKey, '1');
    if (target === options.dataset.current) return;
    const input = document.createElement('input');
    input.type = 'hidden'; input.name = 'language_code'; input.value = target;
    options.closest('form').append(input);
    options.closest('form').submit();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', detect, {once:true});
  else detect();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cubsley-media"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('cb-film'))customElements.define('cb-film',class extends HTMLElement{connectedCallback(){this.abort=new AbortController();this.mq=matchMedia('(max-width:749px)');this.motion=matchMedia('(prefers-reduced-motion:reduce)');this.btn=this.querySelector('.cb-film-control');if(!this.btn)return;this.userPaused=false;this.visible=false;this.btn.addEventListener('click',()=>{if(this.player&&!this.player.paused){this.userPaused=true;this.player.pause()}else{this.userPaused=false;this.mount();this.play(true)}},{signal:this.abort.signal});this.mq.addEventListener('change',()=>this.reset(),{signal:this.abort.signal});this.motion.addEventListener('change',()=>this.reset(),{signal:this.abort.signal});document.addEventListener('visibilitychange',()=>{if(document.hidden)this.player?.pause();else if(this.visible&&this.auto&&!this.userPaused)this.play(false)},{signal:this.abort.signal});this.configure();this.observer=new IntersectionObserver(entries=>{entries.forEach(e=>{this.visible=e.isIntersecting;if(this.visible&&this.auto&&!this.userPaused){this.mount();this.play(false)}else if(!this.visible)this.player?.pause()})},{threshold:.15});this.observer.observe(this)}configure(){const mobile=this.mq.matches;const mode=mobile?this.dataset.mobile:'inherit';this.posterOnly=mobile&&mode==='poster';this.auto=!this.posterOnly&&!this.motion.matches&&!navigator.connection?.saveData&&(mode==='autoplay'||mode==='inherit'&&this.dataset.autoplay==='true');this.source=mobile?(this.querySelector('[data-cb-film-mobile]')||this.querySelector('[data-cb-film-desktop]')):this.querySelector('[data-cb-film-desktop]');this.btn.hidden=this.posterOnly||!this.source;this.updateLabel(false)}mount(){if(this.player||this.posterOnly||!this.source)return;this.player=this.source.content.firstElementChild.cloneNode(true);this.player.muted=true;this.player.loop=this.dataset.loop==='true';this.player.preload='none';if(this.dataset.captions){const track=document.createElement('track');track.kind='captions';track.srclang=document.documentElement.lang;track.label=this.dataset.captionLabel;track.src=this.dataset.captions;this.player.append(track)}this.player.addEventListener('play',()=>{this.dataset.playing='true';this.querySelector('.cb-film-error').hidden=true;this.updateLabel(true)});this.player.addEventListener('pause',()=>this.updateLabel(false));this.player.addEventListener('ended',()=>{this.dataset.playing='false';this.userPaused=true;this.updateLabel(false)});this.player.addEventListener('error',()=>{this.querySelector('.cb-film-error').hidden=false;this.dataset.playing='false';this.updateLabel(false)});this.insertBefore(this.player,this.btn)}play(user){if(!this.player||document.hidden)return;if(!user&&(this.userPaused||!this.auto))return;this.player.play().catch(()=>{this.updateLabel(false)})}updateLabel(playing){if(!this.btn)return;this.btn.querySelector('[data-cb-film-label]').textContent=playing?this.dataset.labelPause:(this.player?.ended?this.dataset.labelReplay:this.dataset.labelPlay);this.btn.firstElementChild.textContent=playing?'Ⅱ':'▷';this.btn.setAttribute('aria-pressed',String(playing))}reset(){if(this.player){this.player.pause();this.player.remove();this.player=null}this.dataset.playing='false';this.userPaused=false;this.configure();if(this.visible&&this.auto){this.mount();this.play(false)}}disconnectedCallback(){this.player?.pause();this.observer?.disconnect();this.abort?.abort()}});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cubsley-system"] && !Shopify.designMode) return;
  try {
    (()=>{const boot=root=>{if(!window.matchMedia('(prefers-reduced-motion: reduce)').matches&&'IntersectionObserver' in window){const observer=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('cb-visible');observer.unobserve(e.target)}}),{threshold:.08});root.querySelectorAll('.cb-reveal:not(.cb-observed)').forEach(el=>{el.classList.add('cb-observed');observer.observe(el)})}};boot(document);document.addEventListener('shopify:section:load',e=>boot(e.target));document.addEventListener('click',e=>{const trigger=e.target.closest('[data-cb-dialog]');if(trigger){const dialog=document.getElementById(trigger.dataset.cbDialog);if(dialog){e.preventDefault();dialog.showModal();dialog.dataset.triggerId=trigger.id||'';const close=dialog.querySelector('[data-cb-close]');close?.focus()}}const closer=e.target.closest('[data-cb-close]');if(closer)closer.closest('dialog').close();if(e.target.tagName==='DIALOG'){const r=e.target.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)e.target.close()}});document.querySelectorAll('dialog').forEach(d=>d.addEventListener('close',()=>{if(d.dataset.triggerId)document.getElementById(d.dataset.triggerId)?.focus()}));document.addEventListener('click',e=>{if(e.target.closest('.cb-mobile-menu a'))e.target.closest('details')?.removeAttribute('open')})})();
  } catch(e) { console.error(e); }
})();

})();
